module.exports = __webpack_public_path__ + "img/arrow.e88b9f7d.svg";